import { useRef, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Link, useNavigate } from "react-router-dom";
import { EmailEditor } from "../components/ui/EmailEditor";
import { useApi } from "../hooks/useApi";

export default function EditTemplate() {
    const { templateId } = useParams();  // Get the site ID from the URL
    const [emailData, setEmailData] = useState(null);
    const { apiCall } = useApi();
    const initialized = useRef(false);
    const [tags, setTags] = useState([]);

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
            apiCall(`fetch_email_template`, { params: { template_id: templateId } })
                .then(response => response.json())
                .then(data => {
                    setEmailData(data);
                    return apiCall(`fetch_replacement_tags`);
                }).then(response => response.json())
                .then(tagsData => {
                    setTags(tagsData);
                })
                .catch(error => console.error("Error fetching the template:", error));

        }
    });

    function processTags(content) {
        if (!content) {
            return '';
        }

        return content.replace(/\[(\w+)\]/g, (match, tagName) => {
            return tags[tagName] !== undefined ? tags[tagName] : match;
        });
    }
    const handleSubmit = async () => {
        try {
            const response = await apiCall(`update_email_template`, {
                method: 'POST',
                body: {
                    id: emailData.id,
                    subject: emailData.subject,
                    message: emailData.message
                }
            });

            const result = await response.json();

            if (result.success) {
                alert('Template updated successfully!');
            } else {
                alert('Error updating template');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Failed to update template');
        }
    };
    const handleChange = (field, value) => {
        setEmailData(prev => ({
            ...prev,
            [field]: value
        }));
    };


    return (
        <>
            <style>{`
        #preview a {
          color: #2563eb !important;
          text-decoration: underline !important;
          cursor: pointer !important;
        }
        #preview a:hover {
          color: #1d4ed8 !important;
        }
        #preview p {
    margin: 0 0 8px 0 !important;
    line-height: 1.5 !important;
}
        
      `}</style>
            {emailData && (
                <div className="m-auto max-w-[1600px]">
                    <div className="flex m-auto justify-center">
                        <div className="p-6  max-w-[800px] min-w-[800px]">
                            <div className="flex justify-between items-center mb-10">
                                <h1 className="text-2xl font-bold uppercase">Edit Template</h1>
                                <Link to={`/email-templates/`} className="btn btn-primary self-end">
                                    Back
                                </Link>
                            </div>

                            <div className="mb-4 ">
                                <h3 className="text-lg font-bold uppercase ">Email Tags:</h3>
                                {
                                    Object.entries(tags).map(([key, value]) => (
                                        <div key={key}>{'[' + key + ']'}: {value}</div>
                                    ))
                                }
                            </div>

                            <div className="space-y-4">
                                <div><strong>Subject:</strong></div>
                                <input
                                    type="text"
                                    placeholder="Add Subject"
                                    value={emailData.subject}
                                    onChange={(e) => handleChange('subject', e.target.value)}
                                    className="border p-2 rounded w-full"
                                    required
                                />
                                <div><strong>Body:</strong></div>
                                <EmailEditor
                                    value={emailData.message}
                                    onChange={(html) => handleChange('message', html)}
                                />


                            </div>
                        </div>
                        <div className="p-6 max-w-[800px] min-w-[500px]">

                            <h3 className="mt-37 mb-12  text-2xl font-bold uppercase">Preview</h3>
                            <div className="mb-4"><strong>Subject:</strong></div>
                            <div className="mb-8" dangerouslySetInnerHTML={{ __html: processTags(emailData.subject) }} />
                            <div className="mb-22"><strong>Body:</strong></div>
                            <div id="preview" dangerouslySetInnerHTML={{ __html: processTags(emailData.message) }} />

                        </div>

                    </div>
                    <div className="flex m-auto justify-center">
                        <div className="flex items-center mr-4">
                            <button type="button" onClick={handleSubmit} className="mr-10 btn btn-primary">Update Template</button>
                            <Link to={`/email-templates/`}>
                                <button type="button" className="btn btn-cancel ml-4">Cancel</button>
                            </Link>
                        </div>
                    </div>
                </div>

            )}
        </>
    );
};